import React from 'react';

interface AIDescriptionSuggestedActionsProps {
  onActionClick: (action: string) => void;
  disabled?: boolean;
}

const ACTIONS = [
  { label: 'Improve', prompt: 'Improve the description.' },
  { label: 'Simplify', prompt: 'Simplify the description.' },
  { label: 'Shorten', prompt: 'Shorten the description.' },
  { label: 'Extend', prompt: 'Extend the description.' },
  { label: 'Challenge', prompt: 'Challenge the description.' },
];

export const AIDescriptionSuggestedActions: React.FC<AIDescriptionSuggestedActionsProps> = ({
  onActionClick,
  disabled = false,
}) => {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {ACTIONS.map((action) => (
        <button
          key={action.label}
          className="flex items-center justify-center px-2 py-0.5 bg-blue-100 border-0 rounded text-sm font-normal leading-5 text-blue-600 cursor-pointer transition-all hover:bg-blue-200 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => onActionClick(action.prompt)}
          disabled={disabled}
        >
          {action.label}
        </button>
      ))}
    </div>
  );
};
